import { FileDomainService } from './domain';

import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';

/**
 * ファイルアプリケーションサービス
 */
export class FileApplicationService {
  private service!: FileDomainService;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.service = new FileDomainService();
    this.service.inject(
      wagakoNurseryApi,
    );
  }

  /**
   * S3ファイルのBlobを取得
   * @param s3Path S3パス
   * @returns blob | undefined
   */
  public async getFileBlob(
    s3Path: string,
    nurseryId: string,
  ) {
    return this.service.getFileBlob(s3Path, nurseryId);
  }

  /**
   * S3画像のBlobを取得
   * @param s3Path S3パス
   * @returns blob | undefined
   */
  public async getImageBlob(
    s3Path: string,
    nurseryId: string,
  ) {
    return this.service.getImageBlob(s3Path, nurseryId);
  }
}
